<template>
  <div id="more-module" class="more-module" data-sidebar="8" data-position="0" data-name="更多精彩">
    <p class="more-title ffm600" v-animate>往下看，更多精彩</p>
    <div class="more-content">
      <MoreCard v-for="item in moreList" :key="item.title" :title="item.title" :upgrade="item.upgrade"
        :newThing="item.newThing" :optimize="item.optimize" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MoreCard from "@/components/MoreCard";
import { MORE_MODULE } from "@/config/image.js";
import { initExposureTrack } from "@/utils/track.js";
export default {
  name: "More",
  components: {
    MoreCard,
  },
  computed: {
    ...mapGetters(['isMobile', 'isPad', 'isPC']),
  },
  data() {
    return {
      MORE_MODULE,
      moreList: [
        {
          title: '锁屏',
          // 新增
          newThing: [
            '时钟位置移动能力，您可以在锁屏编辑页长按时钟拖拽完成时钟调节',
            '经典时钟字体及字重编辑能力，您可以切换时钟字体并调节字体粗细',
            '锁屏通知显示方式，您可选取通知的默认显示方式为数量、叠放和列表',
          ],
          // 优化
          optimize: [
            '锁屏通知显示效果，通知显示位置移至屏幕下方',
            '锁屏底部信息布局方式，提升空间利用率',
          ],
        },
        {
          title: '桌面',
          newThing: [
            '抽屉置顶、文件夹功能，您可以根据自身需求和习惯进行抽屉的设置',
            '抽屉的批量操作功能，您可以进行批量添加应用至桌面、组成文件夹等操作',
          ],
        },
        {
          title: '主题',
          // 优化
          optimize: [
            '壁纸设置与主题设置页面布局与视觉效果，提升使用体验',
            '个性化搭配页面交互，您可点击“搭配”按钮更换不同搭配模板进行自定义',
          ],
        },
        {
          title: '超级拖放',
          // 新增
          newThing: [
            '电话、联系人应用适配超级拖放功能',
          ],
        },
        {
          title: '控制中心',
          // 新增
          newThing: [
            '合并式控制中心展开态音量调节杆，方便您在控制中心直接进行音量调节',
            '控制中心“一键锁屏”控件，为您提供更便利的锁屏方式',
          ],
          // 优化
          optimize: [
            '分离式控制中心音量条与亮度条长按响应速度，降低您在细微调节时的误触率',
          ],
        },
        {
          title: '小V写作',
          // 新增
          newThing: [
            '自定义输入框及扩写、续写、文章、头脑风暴、工作总结写作技能，满足更多、更个性化的写作需求',
            ''
          ],
          // 优化
          optimize: [
            '小V写作功能面板，布局、视觉效果全面升级，体验更优',
          ],
        },
        {
          title: '手机管家',
          // 优化
          optimize: [
            '手机管家全新的设计风格，可快速识别手机存储空间、安全防护、流量消耗状态',
          ],
        },
        {
          title: '多设备互联',
          // 新增
          newThing: [
            '打印的原子岛拖放直达功能，可将选中的图片、文字、文档长按后拖拽至原子岛的“打印”，小窗开始后续的打印任务',
          ],
        },
        {
          title: '深色模式',
          // 优化
          optimize: [
            '深色模式的辨识度和舒适度，白天看得清，晚上不刺眼',
          ],
        },
        {
          title: '安全隐私',
          // 优化
          optimize: [
            '联系人、照片等权限管理逻辑，仅当您主动选择后，相关数据才允许被读取，助您精准掌控数据开放范围，隐私保护更便捷、更安心',
          ],
        },
        {
          title: '系统',
          // 优化
          optimize: [
            '开机引导，带来OriginOS 6全新版本体验',
            '空白页中空态图标的样式及动效',
            '系统应用命名，带来一致的阅读体验',
          ],
        },
      ],
    };
  },
  mounted() {
    // 曝光埋点
    this.$nextTick(() => {
      initExposureTrack(".more-module")();
    });
  },
};
</script>

<style lang="scss" scoped>
.more-module {
  overflow: hidden;
  padding: 0 360 * $px1920vw + vw 180 * $px1920vw + vw 360 * $px1920vw + vw;
  background-color: #F5F5F7;
  position: relative;

  .more-title {
    font-size: 96 * $px1920vw + vw;
    line-height: 115 * $px1920vw + vw;
    text-align: center;
    color: #000000;
    margin-top: 180 * $px1920vw + vw;
  }

  .more-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 80 * $px1920vw + vw;
    grid-column-gap: 25 * $px1920vw + vw;
    margin-top: 160 * $px1920vw + vw;
  }
}

.isPad {
 .more-module {
    overflow: hidden;
    padding: 0 58.55 * $px676vw + vw 90.86 * $px676vw + vw 58 * $px676vw + vw;
    background-color: #F5F5F7;
    position: relative;

    .more-title {
      font-size: 42 * $px676vw + vw;
      line-height: 49 * $px676vw + vw;
      text-align: center;
      color: #000000;
      margin-top: 68 * $px676vw + vw;
    }

    .more-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-row-gap: 48 * $px676vw + vw;
      grid-column-gap: 58 * $px676vw + vw;
      margin-top: 60 * $px676vw + vw;
    }
  }
}

.isMobile {
  .more-module {
    overflow: hidden;
    padding: 0 20 * $px360vw + vw 68 * $px360vw + vw 20 * $px360vw + vw;
    background-color: #F5F5F7;
    position: relative;

    .more-title {
      font-size: 33 * $px360vw + vw;
      line-height: 33 * $px360vw + vw;
      text-align: center;
      color: #000000;
      margin-top: 92 * $px360vw + vw;
    }

    .more-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-row-gap: 36 * $px360vw + vw;
      grid-column-gap: 20 * $px360vw + vw;
      margin-top: 56 * $px360vw + vw;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .isPad,
  .isMobile {
    .more-module {
      background: #222;
      .more-title {
        color: rgba(255, 255, 255, 0.9);
      }
      :deep(.more-content) {
        .more-card {
          .more-title, .more-sub-title {
            color: rgba(255,255,255,0.9);
          }
          .more-des {
            color: rgba(255,255,255,0.6);
          }
        }
      }
    }
  }
}
</style>